import { appConfig } from './AppConfig';

/**
 * Resolves a stored avatar URL to something an <img src> can load.
 * - Absolute URLs (e.g. Spaces CDN) pass through unchanged.
 * - Legacy relative paths (e.g. `/storage/avatars/foo.jpg`) get the backend host prepended.
 * - A locally-picked File (pending upload) wins over the stored URL so the user sees their preview.
 */
export const resolveAvatarSrc = (
    avatarUrl: string | null | undefined,
    localFile?: File | null,
): string | undefined => {
    if (localFile) return URL.createObjectURL(localFile);
    if (!avatarUrl) return undefined;
    if (avatarUrl.startsWith('http')) return avatarUrl;
    return `${appConfig.REACT_APP_BACKEND_URL}${avatarUrl}`;
};
